module.exports = __webpack_public_path__ + "static/media/2017.31d4a123.png";